import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
import Sidebar from './Sidebar';
import Header from './Header';
import MobileBottomNav from '../MobileBottomNav';

interface AppLayoutProps {
  children: React.ReactNode;
}

const AppLayout = ({ children }: AppLayoutProps) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  const userData = JSON.parse(localStorage.getItem('userlogged') || 'null');

  const getPageTitle = (pathname: string) => {
    switch (pathname) {
      case '/diamantes':
        return 'Programa de Benefícios';
      case '/ranking':
        return 'Ranking Vendas';
      case '/nova-venda':
        return 'Nova Venda';
      case '/minhas-vendas':
        return 'Minhas Vendas';
      case '/garantias':
        return 'Garantias';
      case '/home-cliente':
        return 'Área do Cliente';
      case '/minha-rede':
        return 'Minha Rede';
      default:
        return 'Dashboard';
    }
  };

  // Verifica se precisa da navegação mobile inferior
  const shouldShowMobileNav = (
    location.pathname === '/home' || 
    location.pathname === '/nova-venda' || 
    location.pathname === '/minha-rede' ||
    location.pathname === '/meus-cupons'
  ) && (userData?.role === 'revendedora' || userData?.role === 'coordenadora');

  return (
    <div className="min-h-screen bg-background">
      {/* Sidebar */}
      <Sidebar 
        isOpen={sidebarOpen} 
        onToggle={() => setSidebarOpen(!sidebarOpen)} 
      />
      
      <div className="min-h-screen lg:ml-64">
        {/* Header */}
        <Header 
          title={getPageTitle(location.pathname)}
          onMenuToggle={() => setSidebarOpen(!sidebarOpen)}
        />
        
        <main className="min-h-[calc(100vh-73px)]">
          {children}
        </main>
      </div>
      
      {/* Navegação mobile inferior para páginas específicas */}
      {shouldShowMobileNav && <MobileBottomNav />}
    </div>
  );
};

export default AppLayout;